import { useMemo } from "react";

import { ProxifiedUrlsCache } from "@/utils";

import { IImageProxifiedProps } from "./image_proxified.types";
import { ImageProxifiedWithoutCache } from "./image_proxified_without_cache";

export const ImageProxified = (props: IImageProxifiedProps) => {
  const cachedSrc = props.src && ProxifiedUrlsCache.retrieve(props.src);
  return useMemo(() => {
    if (cachedSrc !== undefined) {
      return <img {...props} alt={props.alt} src={cachedSrc || undefined} />;
    }

    return <ImageProxifiedWithoutCache {...props} />;
  }, [cachedSrc, props]);
};
